import { env } from '@/env';

export const DEFAULT_REVALIDATE_TIME = 0;

export const DEFAULT_STALE_TIME = 60 * 5 * 1000;

export const MAX_BYTES_IN_QUERY_PARAMETERS = 1980; // circa 50 ids

export const MAX_PAGE_SIZE = 500;

export const TRACEABLE_CLIENT_TYPES = ['prod', 'dev'] as const;

export const BASE_BACKEND_URL =
  env.NEXT_PUBLIC_BASE_DYNAMIC_BACKEND_URL || env.NEXT_PUBLIC_BASE_BACKEND_URL;

export const BASE_DYNAMIC_BACKEND_PUBLIC_FILE_URL =
  env.NEXT_PUBLIC_BASE_DYNAMIC_BACKEND_URL
    ? `${env.NEXT_PUBLIC_BASE_DYNAMIC_BACKEND_URL}/dev/s3`
    : undefined;

export const QUERY_KEYS = {
  LIST: 'list',
  COUNT: 'count',
  ALL_INSTANCES: 'allinstances',
  ALL_IDS: 'allids',
  GLOBAL_FILTER: 'global-filter',
  STATISTICS: 'statistics',
} as const;

export const NEVER_FETCH_NESTED_FIELDS = [
  'address',
  'tags',
  'mainAddress',
  'postalAddress',
  'invoiceAddress',
  'customerColumns',
  'previousAddress',
  'registeredAddress',
  'currentRegisteredAddress',
  'visitingAddress',
] as const;

export const NEVER_FETCH_NESTED_FIELDS_SET: Set<string> = new Set(
  NEVER_FETCH_NESTED_FIELDS
);

export const NESTED_KEY_SEPARATOR = '@@@' as const;

/**
 * @deprecated Use `env.NEXT_PUBLIC_BASE_CHAT_URL` from `@/env` instead.
 */
export const BASE_CHAT_URL = env.NEXT_PUBLIC_BASE_CHAT_URL;

/**
 * @deprecated Use `env.NEXT_PUBLIC_BASE_LOGIN_URL` from `@/env` instead.
 */
export const BASE_LOGIN_URL = env.NEXT_PUBLIC_BASE_LOGIN_URL;

/**
 * @deprecated Use `env.NEXT_PUBLIC_BASE_PIGELLO_SOCKET_URL` from `@/env`
 * with the dynamic-backend guard where needed.
 */
export const BASE_PIGELLO_SOCKET_URL = !BASE_DYNAMIC_BACKEND_PUBLIC_FILE_URL
  ? env.NEXT_PUBLIC_BASE_PIGELLO_SOCKET_URL
  : undefined;

/**
 * @deprecated Use `env.NEXT_PUBLIC_BASE_FILEUTILS_URL` from `@/env` instead.
 */
export const BASE_FILEUTILS_URL = env.NEXT_PUBLIC_BASE_FILEUTILS_URL;

/**
 * @deprecated Use `env.NEXT_PUBLIC_BASE_ADMIN_URL` from `@/env` instead.
 */
export const BASE_ADMIN_URL = env.NEXT_PUBLIC_BASE_ADMIN_URL;

/**
 * @deprecated Use `env.NEXT_PUBLIC_BASE_INTEGRATION_SERVICE_URL` from
 * `@/env` instead.
 */
export const BASE_INTEGRATION_SERVICE_URL =
  env.NEXT_PUBLIC_BASE_INTEGRATION_SERVICE_URL;

/**
 * @deprecated Use `env.NEXT_PUBLIC_INTEGRATION_MONITOR_URL` from `@/env`
 * instead.
 */
export const BASE_INTEGRATION_MONITOR_URL =
  env.NEXT_PUBLIC_INTEGRATION_MONITOR_URL;

/**
 * @deprecated Use `env.NEXT_PUBLIC_BASE_DASHBOARD_URL` from `@/env` instead.
 */
export const BASE_DASHBOARD_URL = env.NEXT_PUBLIC_BASE_DASHBOARD_URL;

/**
 * @deprecated Use `env.NEXT_PUBLIC_COMMIT_HASH` from `@/env` instead.
 */
export const COMMIT_HASH = env.NEXT_PUBLIC_COMMIT_HASH;

/**
 * @deprecated Use `env.NEXT_PUBLIC_BASE_TF_URL` from `@/env` instead.
 */
export const BASE_TF_URL = env.NEXT_PUBLIC_BASE_TF_URL;

/**
 * @deprecated Use `env.NEXT_PUBLIC_CLIENT_TYPE` from `@/env` instead.
 */
export const CLIENT_TYPE = env.NEXT_PUBLIC_CLIENT_TYPE;
